// Sprint ACAD ACT.A7 (#1708) — End-of-Programme Survey question bank.
//
// Q10 adjudication (Sprint-ACT.A7-recon.md §8): the AC's "source sprint
// plan doc" with the real 12 question strings does not exist anywhere in
// this repo. PLACEHOLDER TEXT ONLY below — this story is not functionally
// complete until AVR supplies the real copy and it's swapped in here. This
// is deliberately a content-only change: swapping `text` values requires no
// other code/schema change (dimension/index/score CHECK constraints and the
// submission payload shape are unaffected by wording).

export type SurveyDimension =
  | 'PLATFORM_EXPERIENCE'
  | 'LEARNING_OUTCOMES'
  | 'CAREER_CONFIDENCE'
  | 'PLACEMENT_PREPAREDNESS';

export interface SurveyQuestion {
  dimension:     SurveyDimension;
  questionIndex: number;
  text:          string;
}

export const DIMENSION_LABELS: Record<SurveyDimension, string> = {
  PLATFORM_EXPERIENCE:    'Platform Experience',
  LEARNING_OUTCOMES:      'Learning Outcomes',
  CAREER_CONFIDENCE:      'Career Confidence',
  PLACEMENT_PREPAREDNESS: 'Placement Preparedness',
};

// TODO(ACT.A7 Q10): replace with the real question text before this story
// ships as done — see recon §8.
export const SURVEY_QUESTIONS: SurveyQuestion[] = [
  { dimension: 'PLATFORM_EXPERIENCE',    questionIndex: 0, text: '[Placeholder] Rate your overall experience using the BluePrint platform.' },
  { dimension: 'PLATFORM_EXPERIENCE',    questionIndex: 1, text: '[Placeholder] Rate the reliability of the platform throughout the programme.' },
  { dimension: 'PLATFORM_EXPERIENCE',    questionIndex: 2, text: '[Placeholder] Rate how easy the platform was to navigate.' },

  { dimension: 'LEARNING_OUTCOMES',      questionIndex: 0, text: '[Placeholder] Rate how much you learned during this programme.' },
  { dimension: 'LEARNING_OUTCOMES',      questionIndex: 1, text: '[Placeholder] Rate how well the programme covered real-world SDLC practices.' },
  { dimension: 'LEARNING_OUTCOMES',      questionIndex: 2, text: '[Placeholder] Rate the quality of feedback you received on your work.' },

  { dimension: 'CAREER_CONFIDENCE',      questionIndex: 0, text: '[Placeholder] Rate your confidence in applying these skills professionally.' },
  { dimension: 'CAREER_CONFIDENCE',      questionIndex: 1, text: '[Placeholder] Rate how prepared you feel for a technical interview.' },
  { dimension: 'CAREER_CONFIDENCE',      questionIndex: 2, text: '[Placeholder] Rate your confidence discussing this project in a portfolio.' },

  { dimension: 'PLACEMENT_PREPAREDNESS', questionIndex: 0, text: '[Placeholder] Rate how well this programme prepared you for placement.' },
  { dimension: 'PLACEMENT_PREPAREDNESS', questionIndex: 1, text: '[Placeholder] Rate your understanding of industry expectations after this programme.' },
  { dimension: 'PLACEMENT_PREPAREDNESS', questionIndex: 2, text: '[Placeholder] Rate your readiness to start a placement role today.' },
];
